import { PageHeader as AntPageHeader, PageHeaderProps } from 'antd';

function PageHeader(props: PageHeaderProps) {
  return <AntPageHeader {...props} style={{ padding: '14px 24px' }} />;
}

export default PageHeader;
